

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'


//icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendar, fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas,fab)

//Sweetalert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


//axios
import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.baseURL=`/api`

//Layout
import Theme from './components/layout/Theme'


//store
import { store } from './store';

//recaptcha
import { VueReCaptcha, useReCaptcha } from 'vue-recaptcha-v3'




createInertiaApp({
  resolve: name => {
    const page = import(`./Pages/${name}`).then(module=>{
     
      module.default.layout = module.default.layout || Theme
       return  module.default
    })
    
    return page
  },
  setup({ el, app, props, plugin }) {
    const captcheKey = props.initialPage.props.recaptcha_site_key;
    return createApp({ render: () => h(app, props) })
      .use(plugin)
      .component('font-awesome-icon', FontAwesomeIcon)
      .use(VueAxios,axios)
      .use(VueSweetalert2)
      .use(store)
      .use(VueReCaptcha, { siteKey: captcheKey } )
      .mount(el)
  },
})
